import * as React from 'react';

import { LoadingSection } from '@coursera/cds-core';

import _t from 'i18n!nls/workspaces-app';

export const NotFound = () => {
  return <LoadingSection hasError label={_t("Sorry, we couldn't find the page you requested.")} />;
};

export default NotFound;
